// extracted by mini-css-extract-plugin
export default {"confirmButton":"ConfirmationModal_confirmButton_b1Nts"};